import React, {useState, useEffect, useContext} from 'react';
import Modal from "react-modal";
import { Bars } from "react-loader-spinner";

import styled from "styled-components";

import {UserContext} from '../../utils/userDetailsProvider';

import SuccessStreamPowerBuyComponent from './SuccessStreamPowerBuyComponent';

import eventBus from '../../utils/globalPubSub';

import { createUserDirectPerk } from '../../utils/perksUtils';
import CancelIcon from "../../assets/cancel_icon.svg";


const BidHeaderStyledSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 130.5%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
`

const GlipHelpTextSpan = styled.span`  
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 140%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.4;
  display: block;
`

const ConfirmPurchaseButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  background: #00E676;
  margin-top: 16px;
  cursor: pointer;
  border-radius: 12px;
`


const ButtonTextSpan = styled.span`
  font-family: IBM Plex Mono;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  text-align: center;
  color: #fff;   
`

const CancelButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 44px;
  background: #F50057;
  margin-top: 16px;
  cursor: pointer;
  border-radius: 12px;
`


export default function ConfirmStreamPowerBuyModalComponent(props:any) {

    let modalWidth = "446px";
    let modalHeight = "250px";

    const userDetails = useContext(UserContext);
    const isMobile = userDetails.isMobile;

    if(isMobile){
        modalWidth = "320px";
    }
    
    const [loader, setIsLoader] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [userDirectPerk, setUserDirectPerk] = useState({});

    useEffect(()=>{
        //setShowSuccess(false);
        setIsLoader(false);
    },[]);
    
    const handleBuyClick = async () => {
        if(loader){
            return;
        }
        setIsLoader(true);
        let userDirectPerk:any = await createUserDirectPerk(
            props.power.id, props.creatorName);
        console.log('userDirectPerk', userDirectPerk);
        if(userDirectPerk.success){
            setShowSuccess(true);
            eventBus.dispatch("success-perk-buy");
            console.log(
                'userDirectPerk.data.directUserPerk',
                userDirectPerk.data.directUserPerk
            );
            setUserDirectPerk(userDirectPerk.data.directUserPerk);
        }
        setIsLoader(false);
        return;
    }

    if(showSuccess){
        return (
            <SuccessStreamPowerBuyComponent
                userDirectPerk={userDirectPerk}
                {...props}
            >
            </SuccessStreamPowerBuyComponent>
        );
    }
    
    return (
        <>  
            <Modal
	        isOpen={props.isOpen}
	        style={{
	            content: {
		        background: "#0F0F0F",
		        width: modalWidth,
		        height: modalHeight,
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
		        border:"none",
                }}}
	    >
                <img onClick={()=>{props.handleModalCloseEvent()}}
                     src={CancelIcon}
	             style={{
		         position: "absolute", opacity: 0.4,
		         height: 14, width:14,
		         right:10, cursor:"pointer",
		         zIndex:10
	             }}
	        />
                <BidHeaderStyledSpan>
	            Buy Stream Power
	        </BidHeaderStyledSpan>
                <div>
                    <ConfirmPurchaseButtonDiv onClick={()=>{handleBuyClick()} }>
                        {(loader) && (
                            <Bars height="30" width="30"
                                  color="grey"
                                  arialLabel="loading-indicator" />
                        )}
                        {(!loader) && (
                            <ButtonTextSpan>
                                Confirm
                            </ButtonTextSpan>
                        )}
                    </ConfirmPurchaseButtonDiv>
                    <CancelButtonDiv onClick={()=>{props.handleModalCloseEvent()}}>
                        <ButtonTextSpan>
                            Cancel
                        </ButtonTextSpan>
                    </CancelButtonDiv>
                </div>
                <GlipHelpTextSpan style={{marginTop:18}}>
	            PS: Money will be deducted from your account <br/>
	        </GlipHelpTextSpan>
                
            </Modal>
        </>
    );
}
